import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ARIALABLES_NAME, PANELPOSITION, ICONVALUE } from './side-panel.constant';

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit {

  public showAriaLabelSpanish = ARIALABLES_NAME.spanish;
  public showAriaLabelEnglish = ARIALABLES_NAME.english;
  public showAriaLabelHindi = ARIALABLES_NAME.hindi;
  public panelPositionLeft = PANELPOSITION.Left;
  public panelPositionRight = PANELPOSITION.Right;
  public backIcon = ICONVALUE.Back;
  public cancelIcon = ICONVALUE.Cancel;
  public isPanelOpen:boolean= true;
  public isPanel1Open: boolean = true;
  public isPanel2Open: boolean = true;
  public activeFloatingPanel: string = '';

  constructor(private activatedRoute: ActivatedRoute, private router: Router) { 
    this.activatedRoute.queryParams.subscribe(response => {
      let isOpenvalue = response['isOpen'].split('-')[2];
      if (response['sidePanel']) {
        this.activeFloatingPanel = response['sidePanel'];
      }
      if (isOpenvalue == 'cancel') {
        if(this.activeFloatingPanel == 'sidepanel1') {
          this.isPanelOpen = false;
        }
        if(this.activeFloatingPanel == 'sidepanel2') {
          this.isPanel1Open = false;
        }
        if(this.activeFloatingPanel == 'sidepanel3') {
          this.isPanel2Open = false;
        }
      }
       if (isOpenvalue == 'back') {
        this.router.navigateByUrl(`/button`);
      }
    });
  };

  ngOnInit(): void {
  }
}
